export const MAX_SCREEN_CONTENT_WIDTH = 1296
export const MEMBERSHIPS_MARKETING_SITE = 'https://tryroll.com/memberships'
export const PINATA_URL = 'https://gateway.pinata.cloud/ipfs'
export const CAMPAIGN_LIST_LIMIT = 40
